import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function IdleTimeOutModal(props) {

    const { show, open, focusAfterClose, handleContinue, handleLogout } = props;

    const [seconds, setSeconds] = React.useState(30);
  
    React.useEffect(() => {
      if (show) {
        if (seconds > 0) {
          setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
          handleLogout();
        }
      }
    });

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleContinue}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"You Have Been Idle!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          Your session is about to expire in{" "}
          <span style={{ color: "red" }}> {seconds} </span> seconds due to
          inactivity. You will be redirected to the login page
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description">
          <Typography>
          You want to stay?
          </Typography>
          </DialogContentText>          
        </DialogContent>
        <DialogActions>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
          <Button color="primary" variant="contained" onClick={handleContinue}>
            Continue Session
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
